export const GROUP_MEMBERS_TYPE = {
    students: 0,
    employee: 1,
    none: -1
};
